import { Layout } from '@/components/Layout/Layout'
import { useRadarNav } from '@/lib/state'
import styles from './cancel.module.css'

const CancelPage = () => {
  const { route } = useRadarNav()
  return (
    <Layout>
      <div data-testid="cancel-page" className={styles.container}>
        <div data-testid="cancel-message" className={styles.content}>
          <div className={styles.icon}>×</div>
          <h1 className={styles.title}>Transaction Cancelled</h1>
          <p className={styles.message}>
            Your Tech Radar license purchase was cancelled. No charges have been
            made to your account.
          </p>
          <div data-testid="cancel-actions">
            <button
              type="button"
              className={styles.button}
              onClick={() => route('')}
            >
              Return to Tech Radar
            </button>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default CancelPage
